import * as yup from "yup";

import { Button, CircularProgress, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/system';
import {
  useAddNewCVMutation,
} from "../lib/cvsSlice";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { v4 as uuidv4 } from "uuid";
import { yupResolver } from "@hookform/resolvers/yup";

const {REACT_APP_NCTC_AI} = process.env;

const ProgressContainer = styled('div')(({ theme }) => ({
  width: '100%',
  '& > * + *': {
    marginTop: theme.spacing(2),
  },
}));

const cvHeaderSchema = yup.object().shape({
  mainRole: yup.string(),
});

function UploadPDF({ handleClose }) {
  const [file, setFile] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [extractedData, setExtractedData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [addNewCV] = useAddNewCVMutation();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);
  const [hasError, setHasError] = useState(false);

  const {
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(cvHeaderSchema),
    defaultValues: {
      mainRole: extractedData?.mainRole || "",
    },
  });

  useEffect(() => {
    const fileData = localStorage.getItem("file");
    if (fileData && !extractedData) {
      setFile(fileData);
      extractData();
    }

    return () => {
      // Clear data from localStorage when the component unmounts
      localStorage.removeItem("file");
    };
  }, [extractedData]);

  async function extractData() {
    const file = localStorage.getItem("file");

    if (typeof file === "string") {
      const parts = file.split(",");
      const data = parts[1];
      const binaryData = atob(data);
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }
      const blob = new Blob([uint8Array], { type: "application/pdf" });
      const formData = new FormData();
      formData.append("cv", blob, "cv.pdf");
      formData.append("name", "Consolata");

      try {
        setIsLoading(true);

        const response = await fetch(`${REACT_APP_NCTC_AI}/text`, {
          method: "POST",
          body: formData,
        });

        if (response.ok) {
          const data = await response.json();
          // Call the submitResults function after a delay
          setExtractedData(data);
          console.log("extractedData:", data);
          setTimeout(() => {
            submitResults(data); // Correct// Pass the extracted data to submitResults
          }, 3000); // Adjust the delay time as needed

        } else {
          console.error("Request failed with status:", response.status);
          setHasError(true);
          toast.error("Failed to extract data", "error");
        }
      } catch (error) {
        console.error("Error:", error);
        setHasError(true); // Set hasError to true when an error occurs
        toast.error("Failed to extract data the PDF", "error");
      } finally {
        setIsLoading(false); // Always set isLoading to false after the request is complete
      }
    }
  }


  const submitResults = async (data) => {
    try {
      const { Position, degree, Company, School } = data || {};

      console.log("this is the data:",data);

      const defaultEducation = {
        institute: School || " ",
        achievement: "NULL",
        fieldOfStudy: degree || " ",
        startMonth: "January",
        startYear: "2010",
        endMonth: "February",
        endYear: "2022",
        description: "NULL",
      };

      const defaultExperience = {
        role: Position || " ",
        startMonth: "NULL",
        startYear: "NULL",
        endMonth: "NULL",
        endYear: "NULL",
        companyName: Company || "NULL",
        // duration: "NULL"
      };

      const cvData = {
        mainRole: Position || "", // Assign Position directly to mainRole
        educations: { id: uuidv4(), ...defaultEducation},
        experiences: { id: uuidv4(), ...defaultExperience},
      };

      console.log("This is cvData.mainRole:", cvData);

      const { mainRole, ...restFormData } = data;

      const requestData = {
        mainRole: cvData.mainRole,
        ...cvData,
        ...restFormData,
      };

      const { data: responseData } = await addNewCV(requestData);

      reset();
      navigate(`/cvdetails/${responseData._id}`);
      handleClose();

      setFile(null);
    } catch (error) {
      console.error("Error submitting results:", error);
      toast.error("Failed to extract data from the pdf", "error");
    }
  };

  function onFileChange(event) {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      localStorage.setItem("file", reader.result);
      setFile(reader.result); // Update the file state with the reader result
      setNumPages(null);
      extractData();
    };

    reader.readAsDataURL(file);
  }

  return (
    <Grid>
      <Grid item xs={12}>
        <ToastContainer
          style={{
            display: isVisible ? "block" : "none",
            transition: "opacity 2s ease-out",
            opacity: isVisible ? 1 : 0,
            borderRadius: "5px",
          }}
        />

        <input
          accept="application/pdf"
          type="file"
          onChange={onFileChange}
          style={{ display: "none" }}
          id="upload-pdf-button"
        />
        <label htmlFor="upload-pdf-button">
          <Button
            variant="contained"
            color="primary"
            component="span"
            size="small"
            startIcon={<CloudUploadIcon />}
          >
            Create with Personal CV (PDF)
          </Button>

          <ProgressContainer>
            {isLoading && <LinearProgress />}
          </ProgressContainer>
        </label>
      </Grid>
    </Grid>
  );
}

export default UploadPDF;